import {} from '/app/cache/ruby/3.0.0/gems/nested_form_fields-0.8.4/lib/assets/javascripts/nested_form_fields.js.coffee'

